/**
 * @voltxampere/ui — AVR ICSP 6-pin header variant (Sprint 49-7)
 *
 * Standard AVR In-Circuit Serial Programming header (2x3, 0.1"
 * pitch). Used with USBasp, AVRISP-mkII, USBtinyISP programmers.
 * Pinout:
 *   1 MISO   2 VCC
 *   3 SCK    4 MOSI
 *   5 RESET  6 GND
 *
 * Reference: Atmel AVR ISP application note (AVR042, 2003).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const connectorIcspHeader = {
    id: "icsp-header",
    nameTr: "ICSP Header (6-pin AVR Programlama)",
    nameEn: "ICSP Header (6-pin AVR Programming)",
    shortcut: "J",
    category: "connector",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "J",
    defaultValue: "ICSP",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 0,
        busType: "icsp-header",
        pinCount: 6,
        pitchInch: 0.1,
        pinout: {
            "1": "MISO",
            "2": "VCC",
            "3": "SCK",
            "4": "MOSI",
            "5": "RESET",
            "6": "GND",
        },
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=connector-icsp-header.js.map